import { Button } from 'reactstrap';

interface Error404PageProps {
  hideGoHome?: boolean;
  /** Replaces "Page Not Found." when the page can say what is missing. */
  message?: string;
}

const Error404Page = ({ hideGoHome = false, message = 'Page Not Found.' }: Error404PageProps) => (
  <div data-testid="not-found-container" className="not-found">
    <div data-testid="not-found-blob" className="not-found-blob">
      <div className="display-text text-white">404</div>
      <div className="body-lg text-white">{message}</div>
      {!hideGoHome ? (
        <Button
          className="ls-button ls-button-primary has-primary mt-3"
          onClick={() => {
            window.location.href = window.location.origin;
          }}
        >
          Go Home
        </Button>
      ) : (
        ''
      )}
    </div>
  </div>
);

export default Error404Page;
